import {Component} from '@angular/core';

@Component({
    selector: 'evs-page-401',
    templateUrl: './page-401-template.html',
    styleUrls: ['./style.css']
})

export class Page401Component{


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/page-error/page-401-component.ts